import ScrollRow from "@components/layout/ScrollRow";
import SubscriptionMovieCard from "@components/SubscriptionMovieCard";

export default function NewSubscriptionSection({
  items,
  title = "Новое в подписке",
}) {
  return (
    <section className="home-movie-row" style={{ padding: "28px 52px 48px" }}>
      <div
        style={{
          fontSize: 32,
          fontWeight: 600,
          color: "#fff",
          textTransform: "uppercase",
          marginBottom: 14,
        }}
        className="jost-s"
      >
        {title}
      </div>
      <ScrollRow cardStyle="calc((100% - 50px) / 6.2)">
        {items.map((item) => (
          <SubscriptionMovieCard item={item} key={item.id} />
        ))}
      </ScrollRow>
    </section>
  );
}
